export const privateLessonMix = {
  data() {
    return {};
  },
  methods: {
    hasSlotsAvailable(event) {
      if (event.private_lessons.first?.status === 'cancelled') {
        // If the first private lesson is cancelled, we assume no slots are available.
        return false;
      }
      const billingPlan = this.getBillingPlan(event);
      // If no billing plan is found, assume slots are available. No billing plan just means that the first wrestler
      // has not selected the group type and set the billing plan yet.
      if (!billingPlan) return true;

      return billingPlan.max_wrestler_count > this.getConfirmedWrestlerCount(event);
    },
    hasWrestlers(event) {
      return event.event_bookings && event.event_bookings.some(booking =>
        booking.profile_type === 'WrestlerProfile'
      );
    },
    getConfirmedWrestlerCount(event) {
      if (!event.event_bookings) return 0;
      return event.event_bookings.filter(booking =>
        booking.profile_type === 'WrestlerProfile' && booking.status === 'confirmed'
      ).length;
    },
    getBillingPlan(event) {
      if (!event.event_bookings) return null;

      // Find the first wrestler booking that has a billing plan
      const wrestlerBookings = event.event_bookings.filter(booking =>
        booking.profile_type === 'WrestlerProfile'
      );

      // Look for a booking with a billing plan
      for (const booking of wrestlerBookings) {
        if (booking.billing_plan) {
          return booking.billing_plan;
        }
      }

      // If no wrestler booking has a billing plan, check for coach booking
      const coachBookings = event.event_bookings.filter(booking =>
        booking.profile_type === 'CoachProfile'
      );

      for (const booking of coachBookings) {
        if (booking.billing_plan) {
          return booking.billing_plan;
        }
      }

      return null;
    },
    getLessonInMinutes(event) {
      if (!event.start_at || !event.end_at) return null;
      const start = new Date(event.start_at);
      const end = new Date(event.end_at);
      const durationMs = end - start;
      return durationMs > 0 ? durationMs / (1000 * 60) : 1; // fallback to 1 hour if invalid
    },
    getSingleWrestlerTotal(event) {
      const billingPlan = this.getBillingPlan(event);
      if (!billingPlan) return 0;
      const duration = this.getLessonInMinutes(event);
      return billingPlan.amount * (duration / 60);
    }
  }
};
